<template>
	<el-dialog 
	:visible.sync="identityCheckDialog"
	width="800px"
	append-to-body
	:close-on-click-modal="false"
	>
		<div id="identityCheck">
			<div class="check-part">
				<div class="part-top">实名认证</div>
				<div class="part-middle">
					<div class="check-start" v-if="checkRes.idCardStatus == 0">
						<div class="tip-for-check">{{ tipForCheck }}</div>
						<div class="check-msg">
							<div class="msg-item">
								<span>真实姓名</span>
								<input type="text" placeholder="姓名与身份证号保持一致" v-model="identityCheckForm.trueName">
							</div>
							<div class="msg-item">
								<span>身份证号</span>
								<input type="text" placeholder="请输入身份证号" v-model="identityCheckForm.identityNumber" maxlength="18">
							</div>
						</div>
						<div class="check-btn" @click="identityCheck()">提交</div>
					</div>
					<!-- <div class="check-wait" v-if="checkRes.idCardStatus == 3">
						<div class="check-msg">
							<img src="" alt="">
						</div>
						<div class="check-btn" @click="identityCheck()">确定</div>
					</div>
					<div class="check-success" v-if="checkRes.idCardStatus == 1">
						<div class="check-msg">
							<img src="" alt="">
						</div>
						<div class="check-btn" @click="identityCheck()">确定</div>
					</div>
					<div class="check-fail" v-if="checkRes.idCardStatus == 2">
						<div class="check-msg">
							<img src="" alt="">
						</div>
						<div class="check-btn" @click="checkRes.idCardStatus = 0">重新认证</div>
					</div> -->
				</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	export default{
		name:"identity",
		data(){
			return {
				tipForCheck:'',
				checkRes:0,
				checkResType:0,
				identityCheckDialog:false,
				identityCheckForm:{
					trueName:'',
					identityNumber:''
				},
			}
		},
		mounted() {
			this.getIdentityCheckRes();
			
			this.getIdentityCheckTip();
		},
		methods:{
			//获取实名认证结果
			getIdentityCheckRes(){
				//+--------------构建请求参数----------------
				//+--------------请求验证结果----------------
				this.apiServer.mine.getIdentityCheckRes()
				.then(res => {
					if(res.data.code == 200){
						if(res.data.data.businessCode != 10){
							this.$message(res.data.data.businessMessage);
							return false;
						}
						
						//更新数据
						this.checkRes = res.data.data;
						
						return this.checkRes;
					}
				})
				.catch(res => {
					this.$message.error('认证结果获取异常');
				})
			},
			
			//获取二要素验证文案
			getIdentityCheckTip(){
				this.apiServer.mine.getIdentityCheckTip()
				.then(res => {
					if(res.data.code == 200){
						
						//更新数据
						this.tipForCheck = res.data.data.tips;
					}
				})
				.catch(res => {
					this.$message.error('获取二要素验证文案异常');
				});
			},
			//二要素验证
			identityCheck(){
				//验证
				if(!this.identityCheckForm.trueName){
					this.$message.error('真实姓名必填');return false;
				}
				if(!this.identityCheckForm.identityNumber){
					this.$message.error('身份证号必填');return false;
				}
				var Expression=/^\d{17}[\d|X]$|^\d{15}$/;
				var objExp=new RegExp(Expression);
				if(!objExp.test(this.identityCheckForm.identityNumber)){
					this.$message.error('身份证格式错误');return false;
				}
				
				//+------------------构建请求参数--------------------
				let data = {
					name:this.identityCheckForm.trueName,
					idNo:this.identityCheckForm.identityNumber,
					applicationType:this.store.state.applicationType
				};
				//+------------------请求二要素验证-----------------
				this.apiServer.mine.identityCheck(this.qs.stringify(data))
				.then(res => {
					if(res.data.code == 200){
						if(res.data.data.businessCode != 10){
							this.$message.error(res.data.data.businessMessage);
							return false;
						}
						
						//更新数据，给出提示
						this.checkResType = res.data.data.type;
						if(this.checkResType != ''){
							this.$message.error(res.data.data.desc);
							return false;
						}
						//关闭dialog
						this.identityCheckDialog = false;
						this.$message.success('认证成功');
						//更新认证结果
						this.getIdentityCheckRes();
					}
				})
				.catch(res => {
					this.$message.error('二要素验证异常');
				});
			}
		}
	}
</script>

<style>
	.check-part{
		/* border: 1px solid red; */
		/* width: 791px;
		height: 650px; */
		background: #FFFFFF;
		border-radius: 18px;
		margin: 0 auto;
	}
	
	.part-top{
		width: 144px;
		height: 50px;
		font-size: 36px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #222222;
		line-height: 50px;
		
		margin-top: 75px;
		margin-left: 85px;
	}
	
	.part-middle{
		
		margin-left: 85px;
	}
	
	.tip-for-check{
		width: 622px;
		height: 50px;
		font-size: 18px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #E31D1A;
		line-height: 25px;
		
		margin-top: 36px;
		margin-bottom: 73px;
	}
	
	.check-msg{
		
	}
	
	.check-start .msg-item span{
		width: 96px;
		height: 33px;
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #2C2C2C;
		line-height: 33px;
	}
	
	.check-start .msg-item{
		margin-bottom: 64px;
	}
	
	.check-start .msg-item input{
		width: 475px;
		height: 32px;
		border-radius: 2px;
		margin-left: 28px;
		border: none;
		border-bottom: 1px solid gray;
		
		font-size: 20px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #8F8F8F;
		line-height: 28px;
	}
	
	
	.part-middle .msg-item img{
		width: 252px;
		height: 237px;
		margin-left: 269px;
		margin-top: 15px;
		
	}
	
	.check-btn{
		width: 620px;
		height: 54px;
		background: #C60B09;
		border-radius: 12px;
		cursor: pointer;
		font-size: 24px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #FFFFFF;
		line-height: 50px;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/identityCheck.vue